import { useEffect, useState } from "react";
import { Popup, PopupBody, PopupFooter } from "../controls";
import { user } from "../../user";
import { useAppDispatch } from "../../effects/useAppDispatch";
import { onBoardingTooltipService } from "../../services";
import { OnBoardingTooltipType } from "../../types/onboarding-tooltips/OnBoardingTooltipType";
import { errorActions } from "../../actions";
import { EmailLink } from "../bidding/common/EmailLink";
import { appConfig } from "../../app-config";
import { usePopupOrder } from "../../effects/usePopupOrder";
import illustration from '../../images/eval-lp/illustration-modal.jpg';

export const evalPopupConst = {
    maxViewsLimit: 3,
};

export function EvalPopupAutoOpener() {
    const onBoardingCounters = user.getOnBoardingTooltipCounters();
    const numberOfViews = onBoardingCounters.EvalPopup ?? evalPopupConst.maxViewsLimit;
    const { setViewed } = useSetEvalPopupViewed();
    const { canShow, markAsShown } = usePopupOrder("Eval");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(visible || !canShow) return;

        if (numberOfViews < evalPopupConst.maxViewsLimit) {
            setVisible(true);
        } else {
            markAsShown?.();
        }
    }, [visible, numberOfViews, canShow, markAsShown])

    const handleClose = () => {
        setViewed();
        markAsShown?.();
        setVisible(false);
    }

    if (!visible) return null;

    return (
        <Popup
            title="Exciting News: KopenTech Launches EVAL™ – Our CLO Pricing Service"
            renderInBody
            onClose={handleClose}
            modalClass="eval-modal"
        >
            <PopupBody>
                <img className="eval-modal-image" src={illustration} alt="" />
                <h2>Now offering a free trial – experience the power of daily CLO pricing.</h2>
                <ul className="list-bullet grey">
                    <li>Full U.S. BSL universe priced daily</li>
                    <li>EUR & MM coverage coming soon</li>
                    <li>Trial access includes up to 250 securities</li>
                </ul>
                <p className="text-medium">
                    Ready to level up your pricing game? To get started, contact us at <EmailLink email={appConfig.salesEmailSubscription} />
                </p>
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" onClick={handleClose}>Close</button>
            </PopupFooter>
        </Popup>
    )
}


export const useSetEvalPopupViewed = () => {
    const dispatch = useAppDispatch();

    const setViewed = async () => {
        const onBoardingCounters = user.getOnBoardingTooltipCounters();
        const count = (onBoardingCounters.EvalPopup || 0) + 1;

        try {
            await onBoardingTooltipService.setCount([{ page: OnBoardingTooltipType.evalPopup, count }])
            user.setOnBoardingTooltipCounter(OnBoardingTooltipType.evalPopup, count)
        } catch (e) {
            dispatch(errorActions.error(e));
        }
    }

    return { setViewed }
}
